import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const factor = async (id: number) => axios.get(Routes.FACTOR + '/' + id);

export const useFactor = (id: number) =>
  useQuery({
    queryKey: [Keys.FACTOR_QRY, id],
    queryFn: () => factor(id),
  });
